// extracted by mini-css-extract-plugin
export default {"main":"layout_main__Zh5BU","main-full-fill":"layout_main-full-fill__VVGR+","settings__wrapper":"layout_settings__wrapper__9rtnF","user":"layout_user__Nqfz8"};